import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfirm = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 22 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0 3)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
			stroke: "currentColor",
			strokeWidth: 2
		}), /* @__PURE__ */ _jsx("path", {
			d: "M7 11.8076L9.61463 14L16 8",
			stroke: "currentColor",
			strokeWidth: 2
		})]
	})
});
export default SvgConfirm;
